import useStatusStore from "../../store/statusStore";
import { getClosureText } from "../../config/hours";

// Dunkle Hinweisleiste unter dem Hero bei kommender oder laufender Schließung.
export default function ClosureBar() {
    const closure = useStatusStore((state) => state.closure);
    if (!closure) return null;

    const text = getClosureText(closure);
    return (
        <div
            role="status"
            className="flex flex-wrap items-center justify-start desk:justify-center gap-2 desk:gap-5 bg-forest px-6 py-3.5 desk:px-12 desk:py-4 text-sm text-creme"
        >
            <span className="text-xs font-bold uppercase tracking-[.2em] text-messing-hell">
                {text.label}
            </span>
            <span>{[text.period, text.reopen].filter(Boolean).join(" ")}</span>
        </div>
    );
}
